import { Paper, styled } from '@mui/material';
import { dividerClasses } from '@/core/ui';
export const DialogTabListItem = styled(Paper)(({ theme }) => [
    {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(3, 5),
        color: theme.palette.slate[700],
        backgroundColor: theme.palette.slate[50],
        borderStyle: 'solid',
        borderWidth: '1px',
        // borderColor: alpha(theme.palette.slate[600], 0.1),
        borderColor: `color-mix(in oklab, ${theme.vars.palette.slate[600]} 10%, transparent)`,
        boxShadow: 'none',
        [`.${dividerClasses.root}`]: {
            marginInline: theme.spacing(-5),
        },
    },
    theme.applyStyles('dark', {
        // backgroundColor: alpha(theme.palette.zinc[800], 0.5),
        backgroundColor: `color-mix(in oklab, ${theme.vars.palette.zinc[800]} 50%, transparent)`,
        color: theme.palette.text.medium,
        // borderColor: alpha(theme.palette.common.white, 0.1),
        borderColor: `color-mix(in oklab, ${theme.vars.palette.common.white} 10%, transparent)`,
    }),
]);
export const TabContent = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
}));
